












































































































































































import { Component, Vue } from "vue-property-decorator";
import HeaderComponent from "@/components/layout/HeaderComponent.vue";
import UserMasterHeaderComponent from "@/components/pages/users/UserMasterHeaderComponent.vue";
import TableComponent from "@/components/common/table/TableComponent.vue";
import TheadComponent from "@/components/common/table/TheadComponent.vue";
import TbodyComponent from "@/components/common/table/TbodyComponent.vue";
import TItemComponent from "@/components/common/table/TItemComponent.vue";
import ButtonComponent from "@/components/common/parts/ButtonComponent.vue";
import PagenationComponent from "@/components/common/parts/PagenationComponent.vue";
import EllipsisComponent from "@/components/common/parts/EllipsisComponent.vue";
import DeleteDialogComponent from "@/components/common/parts/DeleteDialogComponent.vue";
import FooterComponent from "@/components/layout/FooterComponent.vue";
import {
  getUsersEditApi,
  deleteUsersEditApi
} from "../../typescript/api_client/emesh_api/users/users_edit_api";
import {
  GetUsersResponse,
  GetUsersEditResponse
} from "@/typescript/api_client/emesh_api/users/types";
import {
  ValidList,
  Valid,
  AlertFilterList,
  AlertFilter,
  SelectedUsergroup,
  SelectedUser
} from "@/typescript/pages/users/types";
export {
  GetUsersResponse,
  GetUsersEditResponse,
  ValidList,
  Valid,
  AlertFilterList,
  AlertFilter,
  SelectedUsergroup,
  SelectedUser
};
import { getRoutePath } from "@/router/routes";

@Component({
  components: {
    HeaderComponent,
    UserMasterHeaderComponent,
    TableComponent,
    TheadComponent,
    TbodyComponent,
    TItemComponent,
    ButtonComponent,
    PagenationComponent,
    EllipsisComponent,
    DeleteDialogComponent,
    FooterComponent
  }
})
export default class UserMasterShowPage extends Vue {
  $refs!: {
    pagenation: PagenationComponent;
  };

  PAGE_COUNT: number = 20;
  currentPageNo: number = 1;
  usersEdit: GetUsersEditResponse | {} = {};
  selectedValid?: Valid;
  selectedAlertFilter?: AlertFilter;
  selectedUsergroup?: SelectedUsergroup;
  selectedUserName?: SelectedUser;
  inputSearchValue: string = "";
  inputMailAddress: string = "";
  resetSearchKey: number = 0;
  userId: number = 0;
  isDeleteDialogOpen: boolean = false;
  // API 取得時の初期表示用判別フラグ
  isInitialDisplay: boolean = false;

  // 有効フラグ
  get isValid() {
    return 1;
  }

  getRoutePath(pageName: string, params: {}): string {
    return getRoutePath(pageName, params);
  }

  openDialog(userId: number) {
    this.userId = userId;
    this.isDeleteDialogOpen = true;
  }

  closeDelete() {
    this.isDeleteDialogOpen = false;
  }

  deleteData() {
    const deleteData = {
      user_id: this.userId
    };
    deleteUsersEditApi(deleteData)
      .then(() => {})
      .catch(() => {
        alert("削除に失敗しました。");
      })
      .finally(() => {
        this.closeDelete();
        //window.location.reload(false);
        this.resetSearch();
        this.setCurrentPage(1);
      });
  }

  resetSearch() {
    this.selectedValid = undefined;
    this.selectedAlertFilter = undefined;
    this.selectedUsergroup = undefined;
    this.selectedUserName = undefined;
    this.inputSearchValue = "";
    this.inputMailAddress = "";
    this.resetSearchKey = this.resetSearchKey ? 0 : 1;
  }

  async getUserEdit(pageNo: number, params: any = {}) {
    const requiredParams = {
      page_no: pageNo,
      page_count: this.PAGE_COUNT
    };

    if (this.inputMailAddress) {
      params = {
        ...params,
        mailaddress: this.inputMailAddress
      };
    }

    if (this.selectedValid) {
      params = {
        ...params,
        valid_flg: this.selectedValid.value
      };
    }

    if (this.selectedAlertFilter) {
      params = {
        ...params,
        alert_filter: this.selectedAlertFilter.value
      };
    }

    if (this.selectedUsergroup) {
      params = {
        ...params,
        usergroup_id: this.selectedUsergroup.usergroup_id
      };
    }

    if (this.selectedUserName) {
      params = {
        ...params,
        user_id: this.selectedUserName?.user_id
      };
    }

    if (this.inputSearchValue) {
      params = {
        ...params,
        user_name: this.inputSearchValue
      };
    }

    getUsersEditApi({ ...requiredParams, ...params }).then(
      (resp: GetUsersEditResponse) => {
        this.usersEdit = resp;
        this.isInitialDisplay = false;
      }
    );
  }

  created() {
    this.isInitialDisplay = true;
    this.setCurrentPage(1);
  }

  setCurrentPage(pageNo: number) {
    this.currentPageNo = pageNo;
    this.getUserEdit(this.currentPageNo);
  }

  moveNextPage(isMove: boolean) {
    if (!isMove) return;
    this.currentPageNo += 1;
    this.getUserEdit(this.currentPageNo);
  }

  movePrevPage(isMove: boolean) {
    if (!isMove) return;
    this.currentPageNo -= 1;
    this.getUserEdit(this.currentPageNo);
  }

  changeCurrentPageNo(num: number) {
    this.currentPageNo = num;
    this.getUserEdit(this.currentPageNo);
  }

  getItemStartNum(): number {
    if (!this.$refs.pagenation) return 0;
    return this.$refs.pagenation.getItemStartNum();
  }

  getItemEndNum(): number {
    if (!this.$refs.pagenation) return 0;
    return this.$refs.pagenation.getItemEndNum();
  }

  setValue(key: string, value: any) {
    this[key] = value;
  }

  changeFilterItem(key: string, value: any) {
    this[key] = value;
    this.setCurrentPage(1);
  }

  searchUserName(value: string) {
    this.inputSearchValue = value;
    this.setCurrentPage(1);
  }

  searchMailAddress(value: string) {
    this.inputMailAddress = value;
    this.setCurrentPage(1);
  }

  isResult(): boolean {
    const resp = this.usersEdit as GetUsersEditResponse;
    // && を使えば一行で書けるが、コンソール上にて length 参照エラーが出るため、2 行で記述
    if (!Object.keys(resp).length) return true;
    if (resp.users.length <= 0) return true;
    return false;
  }

  // 警告メール通知がONならtrueを返す
  isAlertOn(alertFilter): boolean {
    // 2:警報メールを飛ばさない
    if (alertFilter === 2) return false;
    // 0:発生・復旧ともに警報メールを飛ばす、1:警報発生時のみメールを飛ばす
    return true;
  }
}
